import { render, staticRenderFns } from "./Marcador.vue?vue&type=template&id=bbc0e2b0&scoped=true"
import script from "./Marcador.vue?vue&type=script&lang=ts"
export * from "./Marcador.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./Marcador.vue?vue&type=style&index=0&id=bbc0e2b0&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "bbc0e2b0",
  null
  ,true
)

export default component.exports